import angular, { IDirective } from "angular";
import { ChartJsDirectiveController } from "./controller";
import { Chart } from "chart.js";

export const vsDirectiveName = "chartJs";

chartJsDirective.$inject = <string[]>[];
export function chartJsDirective(): IDirective {
  return {
    restrict: "A",
    bindToController: {
      type: "<",
      chartData: "<",
      options: "<",
    },
    controller: ChartJsDirectiveController,
    link: {
      post(scope, jQuery, _, ctrl) {
        const controller = <ChartJsDirectiveController>ctrl;
        const element = jQuery[0] as HTMLCanvasElement;

        if (!angular.isFunction(element.getContext)) {
          throw new Error("no getContext on element");
        }
        const ctx = element.getContext("2d")!;
        let chartJs: Chart | undefined;

        scope.$watchGroup(
          [() => controller.type, () => controller.chartData],
          updateChart
        );

        function updateChart() {
          if (!chartJs || !(<any>chartJs?.options)?.type) {
            createChart();
            return;
          }

          const data = controller.chartData;
          const chartJsData = chartJs!.data;
          chartJsData.labels = data.labels;
          chartJsData.datasets = data.datasets;

          chartJs?.update();
        }

        function destroyChart() {
          chartJs?.destroy();
          chartJs = undefined;
        }

        function createChart() {
          destroyChart();
          chartJs = new Chart(ctx, {
            data: controller.chartData,
            type: controller.type,
            options: controller.options,
          });
        }

        scope.$on("$destroy", () => {
          destroyChart();
        });
      },
    },
  };
}
